/**
 * JQuery
 */

import $ from "jquery";

window.jQuery = $;
window.$ = $;

/**
 * GSAP
 */

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;

/**
 * Utils
 */

import ajaxFilter from "./utils/ajaxFilter";
ajaxFilter();

import initMap from "./utils/initMap";
window.initMap = initMap;

/**
 * Layout
 */

import navbar from "./layout/navbar";
navbar();

/**
 * Partial
 */

import heroSection from "./partial/heroSection";
heroSection();
